import ProgressBar from "./ProgressBar";
import './Wait.css';

const Wait = ({ progressMessage, progressStage }) => {
  return (
    <div id='wait' className='inner-container'>
      <div className='title'>Generating Routes</div>

      <div className='bump-out'>
        <ProgressBar progressMessage={progressMessage} progressStage={progressStage}></ProgressBar>
      </div>
    </div>
  )
}

export default Wait;